'use strict';

DoohApps
.directive('ngSelected', ['$filter', function ($filter) {
    return {
        restrict: 'EA',
        scope: {
            item: '=item',
            dataselected: '=dataselected'
        },
        link: function (scope, elem, attrs, ctrl) {
            if (scope.dataselected != undefined && scope.dataselected.length > 0) {
                var existMedia = $filter('filter')(scope.dataselected, { MediaAssetID: scope.item.MediaAssetID }, true)[0];
                if (existMedia != undefined) {
                    scope.item.isMediaSelected = true;
                }
            }
        }
    };
}]);